<template>
<div>
    <header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Spiel</h1>
    </header>
    <form @submit.prevent="status == 'ready' ? submitScore() : confirmScore()" id="score">
        <section id="match">
            <router-link :to="`/profile/${match.player_a_id}`" class="player">
                <dp :who="match.player_a" />
                <h3>{{match.player_a.firstname}} {{match.player_a.lastname}}</h3>
            </router-link>
            <div class="vs">vs</div>
            <router-link :to="`/profile/${match.player_b_id}`" class="player">
                <dp :who="match.player_b" />
                <h3>{{match.player_b.firstname}} {{match.player_b.lastname}}</h3>
            </router-link>
        </section>

        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(game, i) in match.games">
                        {{ i+1 }}ter<br>Satz
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="player">
                        <dp :who="match.player_a" />
                        <h3>{{match.player_a.firstname[0] + match.player_a.lastname[0]}}</h3>
                    </td>
                    <td v-for="(game, idx) in match.games" class="form-group">
                        <input type="text"
                               min="0"
                               inputmode="numeric"
                               pattern="[0-9]*"
                               v-model="game.points_a"
                               v-bind:disabled="status != 'ready'"
                               :tabindex="2 * idx + 1"
                               @focus="$event.target.setSelectionRange(0, 9999)"
                               @change="storeLocally">
                    </td>
                </tr>
                <tr>
                    <td class="player">
                        <dp :who="match.player_b" />
                        <h3>{{match.player_b.firstname[0] + match.player_b.lastname[0]}}</h3>
                    </td>
                    <td v-for="(game, idx) in match.games" class="form-group">
                        <input type="number"
                               min="0"
                               inputmode="numeric"
                               pattern="[0-9]*"
                               v-model="game.points_b"
                               v-bind:disabled="status != 'ready'"
                               :tabindex="2 * idx + 2"
                               @focus="$event.target.select()"
                               @change="storeLocally">
                    </td>
                </tr>
            </tbody>
        </table>
        <input type="submit" value="Speichern" class="btn btn-primary center" v-if="status == 'ready'">
        <input type="submit" value="Akzeptieren" class="btn btn-primary center" v-if="status == 'confirming'">
        <a href="#" class="btn btn-link center" @click.prevent="rescore()" v-if="status == 'confirming'">
            Ändern
        </a>
        <a href="#" class="btn btn-link center" @click.prevent="stopRescore()" v-if="rescoring">
            Abbrechen
        </a>
    </form>
</div>
</template>

<script>
import _ from 'underscore'
import base from 'base.vue'
import dp from 'components/dp.vue'

// Detects if localStorage API is available und usable
// From https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
function storageAvailable (type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}

export default {
    mixins: [ base ],
    components: { 'dp': dp },
    data () {
        return { 
            match: {
                player_a: { firstname: '', lastname: '' },
                player_b: { firstname: '', lastname: '' }
            },
            rescoring: false,
            games: [],
            games_orig: []
        }
    },
    computed: {
        status () {
            var me = window.store.state.user.id

            if (this.match.player_a_id === me || this.match.player_b_id === me) {
                if (this.match.status === 'ready') {
                    return 'ready'
                } else if (this.match.status == 'confirming' && (
                    (this.match.scored_by == 'a' && this.match.player_a_id !== me) ||
                    (this.match.scored_by == 'b' && this.match.player_b_id !== me))) {
                    
                    if (!this.rescoring) {
                        return 'confirming'
                    } else {
                        return 'ready'
                    }
                }
            }

            return 'view'
        }
    },
    methods: {
        fetchData () {
            const that = this
            
            return this.$api.get('match/' + this.$route.params.id)
            .then(response => {
                const match = response.data

                // Restore locally stored scores
                if (storageAvailable('localStorage') && match.games.length == 0) {
                    const storedGames = localStorage.getItem(`match-${match.id}`)

                    if (storedGames) {
                        match.games = JSON.parse(storedGames)
                    }
                }

                while (match.games.length < match.num_games && match.status != 'completed') {
                    match.games.push({ points_a: '', points_b: '' })
                }

                that.match = response.data
            })
        },
        submitScore () {
            const that = this
            this.$api.post('match/' + this.match.id + '/submit-score', {
                match_id: this.match.id,
                games: this.match.games
            })
            .then(response => {
                if (storageAvailable('localStorage')) {
                    localStorage.removeItem(`match-${this.match.id}`)
                }

                window.router.push('/')
            })
            .catch(error => {
                that.flash('Ungültiger Punktestand', 'error')
            })
        },
        confirmScore () {
            this.$api.post('match/' + this.match.id + '/confirm-score', {
                match_id: this.match.id
            })
            .then(response => {
                if (storageAvailable('localStorage')) {
                    localStorage.removeItem(`match-${this.match.id}`)
                }

                window.router.push('/')
            })
        },
        rescore() {
            // Remember original scores in case rescoring is aborted
            this.games_orig = _.map(this.match.games, _.clone)

            this.rescoring = true
        },
        stopRescore() {
            this.rescoring = false
            this.match.games = this.games_orig
        },
        // Store entered results locally before submitting
        storeLocally () {
            if (storageAvailable('localStorage')) {
                localStorage.setItem(`match-${this.match.id}`, JSON.stringify(this.match.games))
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// score.vue?5b174406